module.exports = __webpack_public_path__ + "static/img/p3.182852e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p3.png
// module id = jIFz
// module chunks = 0